import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/FaqSection/BaseFaqSectionSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/Section/SectionSkeleton.tsx");
